import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=47bf6d12&scoped=true&"
import script from "./Agency.vue?vue&type=script&lang=js&"
export * from "./Agency.vue?vue&type=script&lang=js&"
import style0 from "./Agency.vue?vue&type=style&index=0&id=47bf6d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf6d12",
  null
  
)

export default component.exports